import React from 'react';
import classes from './TextLink.scss';

const textLink = (props) => {

    let linkTextClass = [classes.LinkText];

    if (props.type === 'normal') {
        linkTextClass.push(classes.LinkTextNormal);
    } else if (props.type === 'fill') {
        linkTextClass.push(classes.LinkTextFill);
    }

    return (
        <a className={linkTextClass.join(' ')} {...props}>{props.children}</a>
    );
}

export default textLink;


// WEBPACK FOOTER //
// ./src/components/UI/TextLink/TextLink.js